import styled from 'styled-components';

const Container = styled.div`
  width: 95%;
  max-width: 1600px;
  margin: var(--space-6) auto;
  padding: 0 var(--space-4);
`;

export const DashboardContainer = styled.div`
  width: 95%;
  max-width: 1600px;
  margin: var(--space-6) auto;
  margin-top: 120px;
  padding: 0 var(--space-4);

  @media (max-width: 768px) {
    margin-top: 80px;
    padding: 0 var(--space-3);
  }
`;

export default Container;
